/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getRestEndpoint } from 'src/app/helpers/api-url';

import { IInsurance } from '../../interfaces/insurance/insurance.interface';

@Injectable({
  providedIn: 'root',
})
export class InsuranceService {
  constructor(private http: HttpClient) {}

  createInsuranceCompany(insuranceCompany: IInsurance): Observable<any> {
    return this.http
      .post<any>(`${getRestEndpoint()}/insurancecompanys`, insuranceCompany)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }

  editInsuranceCompany(insuranceCompany: IInsurance): Observable<any> {
    const insuranceCompanyRecId: number = insuranceCompany.recId;
    return this.http
      .put<any>(
        `${getRestEndpoint()}/insurancecompanys/${insuranceCompanyRecId}`,
        insuranceCompany,
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }
}
